<template>
    <div class="background-image">
        <div class="splash-container">
          <img alt="skillsync" src="../assets/logo-splash.png" />
          <h2>Empower Your Recruitment Strategy without Overspending</h2>
          <p class="tagline">Unlock Potential: Efficiently Identify Top Talent with Innovative Assessment Tools</p>
          <p>Discover the best talents effortlessly with our assessment tools.</p>
          <div class="d-flex flex-column p-3">
            <div class="row">
              <div class="col">
                <router-link to="/login" class="login-link">Login</router-link>
              </div>
              <div class="col">
                OR
              </div>
              <div class="col">
                <router-link to="/signup" class="login-link">Signup</router-link>
              </div>
            </div>
          </div>
        </div>
    </div>
  </template>
  
  <script>
  import Galleria from 'primevue/galleria';
  export default {
    name: 'SplashPage',
    components: {
      Galleria
    },
    data() {
      return {
        images: [
          { itemImageSrc: require('@/assets/screenshots/001-large.png'), thumbnailImageSrc: require('@/assets/screenshots/001-large.png'), alt: 'Description' },
          { itemImageSrc: require('@/assets/screenshots/002-large.png'), thumbnailImageSrc: require('@/assets/screenshots/002-large.png'), alt: 'Description' },
          { itemImageSrc: require('@/assets/screenshots/003-large.png'), thumbnailImageSrc: require('@/assets/screenshots/003-large.png'), alt: 'Description' },
          // Add more image objects as needed
        ],
          // Example responsiveOptions
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 5,
            numScroll: 3
          },
          {
            breakpoint: '768px',
            numVisible: 3,
            numScroll: 2
          },
          {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>

      .auth-links {
      position: absolute; /* or 'fixed' if you want it to stay in place on scroll */
      top: 0;
      right: 0;
      padding: 20px;
      display: flex;
      gap: 10px; /* Adjusts the space between the links */
      align-items: center;
      justify-content: center;
    }

    .auth-separator {
      color: #fff; /* Adjust color to match your design */
    }

    .background-image {
    /* Set background image */
    background-image: url('../assets/splash-background.png');
    
    /* Adjust background properties */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    /* Set size to cover entire viewport by default */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    }


  h2 {
    font-family: 'montserrat';
    text-shadow: 1px 1px 2px black;
  }

  .splash-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    /*background: linear-gradient(145deg, #5f2c82, #4f4f4f);*/
    color: #fff;
  }
  
  .tagline {
    font-size: 1.2em;
    margin: 20px 0;
  }
  
  .login-link {
    margin-top: 30px;
    padding: 10px 20px;
    background-color: #382d61;
    border-radius: 5px;
    color: #fff ;
    text-decoration: none;
    font-weight: bold;
    min-width: 200px;
  }
  @font-face {
    font-family: 'montserrat';
    src: url('../assets/fonts/montserrat/Montserrat-ExtraBoldItalic.ttf');
  }

  @media only screen and (max-width: 600px) {
    h2 {
        font-family: 'montserrat';
        text-shadow: 1px 1px 2px black;
        font-size: 1em;
    }
  }
  </style>